import {useCallback, useEffect} from 'react';

import {
  computeSidePanelTrackingFrameName,
  computeSidePanelTrackingTrackingFramePayload,
} from '../../../helpers/sidePanelTrackingHelpers';
import {trackEvent, TrackingTypesEnum} from '../../../services/tracking';
import {SidePanelFrame} from '../../../store/stateless/sidePanelFrameSelectors';

/*
 * Helpers.
 */

export function useSelectedFrameLogging(
  selectedFrame: SidePanelFrame | undefined,
  lastSelectedFrame: SidePanelFrame | undefined,
) {
  const logFrameChange = useCallback(
    (frame: SidePanelFrame | undefined, lastFrame: SidePanelFrame | undefined) => () => {
      // If the sidePanel is closed, then log a close event with the panel that
      // was closed and return.
      if (!frame) {
        trackEvent(
          TrackingTypesEnum.INTEGRATION_CLOSE,
          computeSidePanelTrackingFrameName(lastFrame),
          computeSidePanelTrackingTrackingFramePayload(lastFrame),
        );

        return;
      }

      // Otherwise, track an open event for the current selected frame.
      trackEvent(
        TrackingTypesEnum.INTEGRATION_OPEN,
        computeSidePanelTrackingFrameName(frame),
        computeSidePanelTrackingTrackingFramePayload(frame),
      );
    },
    [],
  );

  useEffect(() => {
    const timeout = setTimeout(logFrameChange(selectedFrame, lastSelectedFrame), 5000);
    return () => clearTimeout(timeout);
  }, [selectedFrame, lastSelectedFrame, logFrameChange]);
}
